import {
  COMPONENT_STATE_ARGS,
  MENU_ARGS,
  getDefaultValueFromMetadata,
  pickArgs,
  sortMetadata,
} from '../../../../../utils/spds/metadata';
import { hash } from '@ember/helper';
import Menu from '../../../core/menu/base.gjs';
import MenuItem from './menu-item.gjs';
import Super from '../../../core/base.gjs';

const METADATA = sortMetadata({
  component: 'Spds::Action::Button::Dropdown::Menu',
  description: 'Menu component for dropdown buttons',
  meta: {
    animated: {
      ...COMPONENT_STATE_ARGS.meta.animated,
      defaultValue: true,
    },
    ...pickArgs(COMPONENT_STATE_ARGS, ['open']).meta,
    ...pickArgs(MENU_ARGS, ['anchorElement']).meta,
    toggleOpenState: {
      type: 'function',
      description: 'Function to toggle the open state of the menu',
    },
  },
  name: 'Dropdown Menu',
});

export default class SpdsActionButtonDropdownMenu extends Super {
  static metadata = this.setMetadata(METADATA);
  componentName = 'Spds::Action::Button::Dropdown::Menu';

  get animated() {
    return this.args.animated ?? getDefaultValueFromMetadata(this.constructor.metadata, 'animated');
  }

  <template>
    <Menu
      @anchorElement={{@anchorElement}}
      @animated={{this.animated}}
      @open={{@open}}
      data-test-spds-action-button-dropdown-menu
      role="menu"
      {{this.validateArguments}}
    >
      {{yield
        (hash
          Item=(component
            MenuItem showSelectedStyles=false role="menuitem" toggleOpenState=@toggleOpenState
          )
        )
      }}
    </Menu>
  </template>
}

export const ACTION_BUTTON_DROPDOWN_MENU_METADATA = SpdsActionButtonDropdownMenu.metadata;
